import { Signal } from '@angular/core';
import { FeedNotification } from './notification-feed.model';

// Abstract contract for the in-app notification feed. Implemented today by a
// localStorage-backed synthesiser off `/users/me/matches`; swappable later for
// an API-backed impl (blocked by #1697).
export abstract class NotificationFeedService {
  abstract readonly notifications: Signal<readonly FeedNotification[]>;
  abstract readonly unreadCount: Signal<number>;

  abstract refresh(): Promise<void>;
  abstract markRead(id: string): void;
  abstract markAllRead(): void;
}
